import { lazy } from 'react';
import i18next from 'i18next';
import { authModules } from 'app/auth';
import enGB from '@locales/password/enGB';
import deAT from '@locales/password/deAT';

i18next.addResourceBundle('enGB', 'password', enGB);
i18next.addResourceBundle('deAT', 'password', deAT);

const ResetPassword = lazy(() => import('./ResetPassword'));

const ResetPasswordConfig = {
	settings: {
		layout: {
			config: {
				navbar: {
					display: false
				},
				toolbar: {
					display: false
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	},
	auth: authModules.notloggedin,
	routes: [
		{
			path: '/resetpassword',
			element: <ResetPassword />
		}
	]
};

export default ResetPasswordConfig;

